/* eslint-disable no-undef */
import axios from 'axios';


const baseURL = `https://sheetdb.io/api/v1/${process.env.REACT_APP_SHEET_DB_KEY}`
export const instance = axios.create({
  baseURL: baseURL,
  timeout: 10000,
  headers: {
    'Access-Control-Allow-Origin': '*',
  },
});
